import React, { useMemo, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Mail, ArrowRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL ? `${BACKEND_URL.replace(/\/$/, '')}/api` : '/api';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const canSubmit = useMemo(() => email.trim() !== '' && !loading, [email, loading]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const val = email.trim();
    if (!val) return;

    setLoading(true);
    try {
      await axios.post(
        `${API}/auth/forgot-password`,
        { email: val },
        { withCredentials: true }
      );
      toast.success('Se o e-mail estiver cadastrado, enviamos um link para redefinir sua senha.');
      setEmail('');
    } catch (error) {
      toast.error(error?.response?.data?.detail || 'Erro ao solicitar redefinição de senha');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0f172a] p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-2">Esqueceu sua senha?</h2>
          <p className="text-slate-600 dark:text-slate-400">
            Informe seu e-mail e enviaremos um link para redefinição.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-slate-700 dark:text-slate-300 font-medium">E-mail</Label>
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
              <Input
                id="email"
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="pl-12 h-12 bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
              />
            </div>
          </div>

          <Button
            type="submit"
            className="w-full h-12 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white rounded-xl font-semibold shadow-lg shadow-cyan-500/25 hover:shadow-cyan-500/40 transition-all duration-300"
            disabled={!canSubmit}
          >
            <span className="flex items-center justify-center">
              {loading ? 'Enviando...' : 'Enviar link'}
              <ArrowRight className="ml-2 h-5 w-5" />
            </span>
          </Button>
        </form>

        <p className="text-center mt-6 text-sm text-slate-600 dark:text-slate-400">
          Lembrou a senha?{' '}
          <Link to="/auth" className="text-cyan-600 hover:text-cyan-700 font-semibold hover:underline">Voltar ao login</Link>
        </p>
      </div>
    </div>
  );
};
